import __base_store from '@/store/__base_store'

/**
 * Store de pagos de Mercado Libre (modelo `me_li_payment`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'me_li_payment',
	},
})

